import React, { useCallback } from "react";
import { throttle } from "lodash";
import styled from "styled-components";
import { useAxios } from "../../../hooks";
import { objectFromFormData } from "./brandDetailObject";
import { useDispatch } from "react-redux";
import { alert } from "../../../redux/slices/alertSlice";

const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Label = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #0234ad;
`;

const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 52px;
  height: 26px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  input:checked + span {
    background-color: #5a8bf2;
  }

  input:checked + span:before {
    transform: translateX(26px);
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: "";
    height: 20px;
    width: 20px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
  }
`;

export const BrandStatusToggle = ({
  editState,
  formikProps,
  businessEntityID,
}) => {
  const axios = useAxios();
  const dispatch = useDispatch();

  const throttledUpdateBrand = useCallback(
    throttle(async (formData) => {
      try {
        let url = "/user/brand/" + formData.brandID;
        let method = "PUT";
        await axios({
          url: url,
          method: method,
          data: {
            ...objectFromFormData(formikProps.values, businessEntityID),
            is_visible: formData.isVisible,
          },
          disableRedirect: true,
        }).then((res) => {
          if (res.status) {
            dispatch(
              alert({
                type: "success",
                message: res.message.displayMessage,
              })
            );
          }
        });
      } catch (error) {
        console.error("Brand status update failed:", error);
      }
    }, 1200),
    []
  );

  const handleStatusChange = (e) => {
    const newValue = e.target.checked;

    formikProps.setFieldValue("isVisible", newValue);

    const formData = {
      brandID: formikProps.values.brandID,
      isVisible: newValue,
    };
    if (formikProps.values.brandIDa) {
      throttledUpdateBrand(formData);
    }
  };

  return (
    <ToggleWrapper>
      <Label>Brand Status</Label>

      <Switch>
        <input
          disabled={!editState}
          type="checkbox"
          name="isVisible"
          checked={formikProps.values.isVisible}
          onChange={handleStatusChange}
        />
        <Slider />
      </Switch>

      <Label
        style={{
          color: formikProps.values.isVisible ? "#5a8bf2" : "#999",
        }}
      >
        {formikProps.values.isVisible ? "Active" : "Inactive"}
      </Label>
    </ToggleWrapper>
  );
};
